import { ToastPosition } from 'react-toastify';

export const toastGeneralConfig = {
  position: 'top-right' as ToastPosition,
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  pauseOnFocusLoss: false,
};
